<div style="padding: 2rem;">

  <!-- Page header -->
  <div style="margin-bottom: 1.75rem;">
    <h1 style="font-size: 1.5rem; font-weight: 700; color: #1e293b; margin: 0 0 0.25rem;">
      Détails de parainages
    </h1>
    <p style="font-size: 0.875rem; color: #64748b; margin: 0;">Gestion des détails parainages</p>
  </div>

  <!-- Stats cards -->
  <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem; margin-bottom: 1.75rem;">
    <div class="afri-card" style="text-align: center; padding: 1.5rem;">
      <h1 style="font-size: 2rem; font-weight: 700; color: #2E3190; margin: 0 0 0.5rem;">{{global_gains?.gain1}}</h1>
      <h6 style="font-size: 0.875rem; color: #64748b; margin: 0;">Total gain de niveau 1</h6>
    </div>
    <div class="afri-card" style="text-align: center; padding: 1.5rem;">
      <h1 style="font-size: 2rem; font-weight: 700; color: #2E3190; margin: 0 0 0.5rem;">{{global_gains?.gain2}}</h1>
      <h6 style="font-size: 0.875rem; color: #64748b; margin: 0;">Total gain de niveau 2</h6>
    </div>
    <div class="afri-card" style="text-align: center; padding: 1.5rem;">
      <h1 style="font-size: 2rem; font-weight: 700; color: #2E3190; margin: 0 0 0.5rem;">{{global_gains?.gain3}}</h1>
      <h6 style="font-size: 0.875rem; color: #64748b; margin: 0;">Total gain de niveau 3</h6>
    </div>
    <div class="afri-card" style="text-align: center; padding: 1.5rem;">
      <h1 style="font-size: 2rem; font-weight: 700; color: #2E3190; margin: 0 0 0.5rem;">{{global_gains?.total}}</h1>
      <h6 style="font-size: 0.875rem; color: #64748b; margin: 0;">Total gain</h6>
    </div>
  </div>

  <!-- Main card -->
  <div class="afri-card">

    <!-- Card header: count -->
    <div class="afri-card-header">
      <div></div>
      <div class="flex items-center gap-2" style="font-size: 0.875rem; color: #64748b;">
        <span style="font-weight: 700; color: #1e293b; font-size: 1rem;">{{ data!.length }}</span>
        élément(s)
        <app-loading [isVisible]="loading2"></app-loading>
      </div>
    </div>

    <!-- Table -->
    <div style="overflow-x: auto;">
      <table class="afri-table">
        <thead>
          <tr>
            <th style="width: 52px; padding-left: 1.5rem;">#</th>
            <th>Achat</th>
            <th>Niveau</th>
            <th>Gain 1</th>
            <th>Gain 2</th>
            <th>Gain 3</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let r of data">
            <tr style="background-color: rgb(96, 156, 209);">
              <td colspan="3"><b>Parrain: </b>{{r?.owner_detail?.lastname}} {{r?.owner_detail?.firstname}}</td>
              <td colspan="4"><b>Filleul: </b>{{r?.invited_detail?.lastname}} {{r?.invited_detail?.firstname}}</td>
            </tr>
            <tr *ngFor="let d of r.details | paginate: {
                  id: 'ngxP1',
                  itemsPerPage: pg.pageSize,
                  currentPage: pg.p,
                  totalItems: pg.total
                } | sampleSearch:search_text"
                [style.background]="selected_data?.id === d.id ? '#f0f4ff' : ''">
              <td style="padding-left: 1.5rem;">
                <input (click)="checked(d)" type="radio" name="selectRow"
                       style="width: 16px; height: 16px; accent-color: #2E3190; cursor: pointer;">
              </td>
              <td>{{d.order?.amount}}</td>
              <td>{{d.level}}</td>
              <td>{{d.gain1}}</td>
              <td>{{d.gain2}}</td>
              <td>{{d.gain3}}</td>
              <td>{{d.created_at | date:"dd/MM/yyyy"}}</td>
            </tr>
            <tr>
              <td colspan="3"><b>Total :</b></td>
              <td><b>{{r.total_gains?.gain1}}</b></td>
              <td><b>{{r.total_gains?.gain2}}</b></td>
              <td><b>{{r.total_gains?.gain3}}</b></td>
              <td><b>{{r.total_gains?.total}}</b></td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <div style="padding: 0.5rem 1.5rem 1.25rem;">
      <pagination-controls
        id="ngxP1"
        (pageChange)="getPage($event)"
        [maxSize]="9"
        [directionLinks]="true"
        [autoHide]="true"
        [responsive]="true"
        [previousLabel]="'Précédent'"
        [nextLabel]="'Suivant'">
      </pagination-controls>
    </div>

  </div><!-- end card -->
</div>
